// Lightweight feature-flag context for the app.
//
// MainApp fetches GET /features once it has a token and provides the resolved
// {flag_key: bool} map here. Components gate UI with:
//
//     import { useFeature } from "../featureFlags";
//     const showNewThing = useFeature("example_new_feature");
//     ...
//     {showNewThing && <NewThing />}
//
// Unknown/unset flags resolve to false, so gated UI stays hidden by default.
import { createContext, useContext } from "react";

export const FeatureFlagsContext = createContext({});

export function useFeatures() {
  return useContext(FeatureFlagsContext) || {};
}

export function useFeature(key) {
  const flags = useFeatures();
  return !!flags[key];
}
